import PrintHeader from '../components/layout/PrintHeader';
import Printooter from '../components/layout/PrintFooter';

export interface LayoutPrintProps {
  children: React.ReactNode;
}

const PrintPage: React.FC<LayoutPrintProps> = ({ children }) => (
  <>
    <PrintHeader />
    <main>{children}</main>
    <Printooter />
  </>
);
 
export default PrintPage;